
import { types } from "../types"


export const getProfile = () => {
    return {
        type: types.GET_PROFILE_REQUEST,

    }
}
export const resetPropsGetProfile = () => {
    return {
        type: types.GET_PROFILE_RESET_PROPS,

    }
}



export const setOnlineStatusAction = (status) => {
    return {
        type: types.SET_ONLINE_STATUS,
        status
    }
}




